import type { Address } from '../types'

export const EMPTY_ADDRESS: Address = {
  street: '',
  city: '',
  state: '',
  postalCode: '',
  neighborhood: '',
  number: '',
  complement: '',
  country: '',
  receiverName: '',
  addressId: '',
  isDisposable: false,
  addressType: '',
}
